import { SideMenuItemDto } from '@core/dtos/side-menu-items.dto';
import { SideMenuItem } from '@core/interfaces/entities/side-menu-items.interface';
import { Mapper } from './mapper';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SideMenuItemsMapper extends Mapper<SideMenuItem, SideMenuItemDto> {
  mapFrom(data: SideMenuItem): SideMenuItemDto {
    const labelKey: string = data.label_key ? `menu.${data.label_key}` : data.title;
    
    return {
      id: data.id,
      icon: data.icon,
      label: labelKey,
      hidden: data.hidden,
      active: data.active,
      expanded: false,
      route: data.url,
      hasSubMenu: data.modules ? true : false,
      subItems: this.mapFromArray(data.modules || []),
    };
  }
}
